
import { Header } from "./Header";


export const Overlay = ({ referrer }) => (
  <div className="left-box-overlay" id="main-map-overlay">
    <Header referrer={referrer} />
    <h2 className="chart-title" style={{fontWeight:"900", lineHeight:"28px", fontSize:"20px" }}>
    Explore how nearly every NYC neighborhood shifted toward Trump in 2024
    </h2>

    <p className="chart-dek ml-0" style={{lineHeight:"22px"}}>
    The GOP vote share in the five boroughs rose in almost every neighborhood, according to unofficial results. Hover over the map to see how the shift from blue to red broke down between 2020 and 2024.
    </p>
    <div style={{ marginBottom: "5px" }}>
      <a
        className="chart-dek"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#ebf87e",
          border: "1.5px solid #ebf87e",
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingLeft: "5px",
          paddingRight: "5px",
          textDecoration: "none",
          borderRadius: "15px",
          fontSize: "14px",
        }}
        href="https://projects.thecity.nyc/election-results-voter-turnout-Harris-Trump-map/"
      >
        2024 Presidential Election Results Map
      </a>
    </div>
    <div className="chart-dek" style={{marginLeft:"0px",color:"white", fontSize:"12px", fontStyle:"italic", lineHeight:"15px"}}>*Mapped with unofficial election results. Data by Haidee Chu, Designed & Developed by Sujin Shin</div>
    <div className="map-geocoder-placeholder" />
  </div>
);
